<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2" color="blue">mdi-sim</v-icon>
      {{ t.dashboard?.sim_advanced_search || 'Advanced SIM Search' }}
    </v-card-title>
    <v-card-text>
      <SimSearchFilters
        v-model:search-term="searchTerm"
        v-model:client-id="selectedClientId"
        v-model:include-subclients="includeSubclients"
        v-model:status-id="selectedStatusId"
        :use-chips="true"
        :always-allow-search="!isMultilevelReseller"
        @search="search"
        @reset="onReset"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import SimSearchFilters from '@/components/SimSearchFilters.vue'
import store from '@/store'

export default {
  name: 'SimAdvancedSearchSection',
  components: { SimSearchFilters },
  props: {
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      searchTerm: '',
      selectedClientId: null,
      includeSubclients: true,
      selectedStatusId: 'all_except_terminated'
    }
  },
  computed: {
    t() { return tRef.value },
    isMultilevelReseller() {
      const ct = store.getters.getUser?.client_type_name?.toLowerCase() || ''
      return ct === 'multilevel'
    }
  },
  methods: {
    search() {
      const query = {}
      const minLen = this.isMultilevelReseller ? 3 : 1

      if (this.searchTerm?.trim().length >= minLen) {
        query.search = this.searchTerm.trim()
      }

      if (this.selectedClientId) {
        query.client_id = this.selectedClientId
        query.include_subclients = this.includeSubclients
      }

      if (this.selectedStatusId && this.selectedStatusId !== 'all_except_terminated') {
        query.status = this.selectedStatusId
      }

      this.$router.push({ name: 'sims', query })
    },
    onReset() {
      // Filters are already reset by the component
    }
  }
}
</script>
